import React from "react";

import "../assets/css/spinner.min.css"

function Spinner() {
  return (
    <div class="lds-ellipsis">
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}

export default Spinner;
